import React, {useEffect} from "react";
import {observer} from 'mobx-react'

import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {routes} from "../../App";
import '../component.scss';
import {useStores} from "../../Hooks";
import Utility from "../../Utility";
import {generalStore, history} from '../../index';
import GlobalUtility from "../../Utilities/GlobalUtility";
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import DesignServicesOutlinedIcon from '@mui/icons-material/DesignServicesOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MovingIcon from '@mui/icons-material/Moving';
import FilterDramaIcon from '@mui/icons-material/FilterDrama';
import DeploymentIcon from "../../assets/svg-icons/DeploymentIcon";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import CrownIcon from '../../assets/svg-icons/CrownIcon';
import { ReactComponent as IntegrationsIcon } from '../../assets/img/integrationsIcon.svg'
import {WorkspaceFlags} from "../../serverClientShared/sharedEnums";

const DomainSidebar = observer(() => {
    const {generalStore} = useStores();
    const domainRoutes = [
        {
            path: routes.MEMBERS,
            name: generalStore.translate('members'),
            icon: PeopleOutlinedIcon,
            included: true,
            testId: 'domain-sidebar-members',
        },
        {
            path: routes.GROUPS,
            name: generalStore.translate('groups'),
            icon: Groups2OutlinedIcon,
            included: true,
            testId: 'domain-sidebar-groups',
        },
        {
            path: routes.ROLES,
            name: generalStore.translate('roles'),
            icon: CrownIcon,
            included: !!generalStore.domainSettings?.IsNewRolesSystemEnabled,
            testId: 'domain-sidebar-roles',
        },
        {
            path: routes.WORKSPACE_SETTINGS,
            name: generalStore.translate('workspaceDesign'),
            icon: DesignServicesOutlinedIcon,
            included: true
        },
        {
            path: routes.SUB_WORKSPACE_MANAGEMENT,
            name: 'Sub-Workspaces',
            icon: AccountTreeOutlinedIcon,
            included: GlobalUtility.isFlagOn(generalStore, 'Channel'),
            testId: 'domain-sidebar-sub-workspaces',
        },
        {
            path: routes.AI_STUDIO,
            name: 'AI Studio',
            icon: AutoAwesomeIcon,
            included: GlobalUtility.isFlagOn(generalStore, 'CanAddAiChatKnowledge')
        },
        {
            path: routes.GLOBAL_AI_STUDIO,
            name: 'Global AI Studio',
            icon: AutoAwesomeIcon,
            included: generalStore.userDetails.IsFrontlineContentCreatorUser
        },
        // {
        //     path: routes.WORKSPACE_LANGUAGE,
        //     name: generalStore.translate('languageSettings'),
        //     icon: TranslateIcon
        // },
        {
            path: routes.WORKSPACE_PAY_PER_CLICK,
            name: generalStore.translate('payPerClick'),
            icon: MovingIcon,
            included: true,
        },
        // {
        //     path: routes.WORKSPACE_INTEGRATIONS,
        //     name: generalStore.translate('integrations'),
        //     icon: PowerIcon,
        // }
        {
            path: routes.SSO,
            name: 'SSO',
            icon: FilterDramaIcon,
            included: true,
        },
        {
            path: routes.POWER_BI_EXPORT,
            name: 'Power BI export',
            icon: FileUploadIcon,
            included: true,
        },
        {
            path: routes.QR_CODE,
            name: 'Static QR codes',
            icon: QrCode2Icon,
            included:  GlobalUtility.isFlagOn(generalStore, 'IsQrCodeEnabled')
        },
        {
            path: routes.WORKSPACE_DEPLOYMENT,
            name: generalStore.translate('deployment'),
            icon: DeploymentIcon,
            included: generalStore.isWorkspaceOwner && GlobalUtility.isFlagOn(generalStore, 'HasStaging')
        },
        {
            path: routes.Integrations,
            name: 'Integrations',
            icon: IntegrationsIcon,
            included: GlobalUtility.isFlagOn(generalStore, 'IsIntegrationEnabled')
        },
        {
            path: routes.RemoteSupportManagement,
            name: 'Remote Support Settings',
            icon: HeadsetMicIcon,
            included: GlobalUtility.isFlagOn(generalStore, WorkspaceFlags.REMOTE_SUPPORT_SETTINGS)
        }
    ];

    if (generalStore.isWorkspaceOwner && generalStore.domainSettings?.HasStaging) {
        domainRoutes.push({
            path: routes.WORKSPACE_DEPLOYMENT,
            name: generalStore.translate('deployment'),
            icon: DeploymentIcon,
        });
    }
    const hideTopBar = generalStore.hideTopBar;

    function changeRoute(route) {
        history.push(route.path);
    }

    function getIsActive(path) {
        const pathSplitted = window.location.pathname.split('/');
        const routPathPart = pathSplitted.pop();
        return `/${routPathPart}` === path;
    }

    function getListItemClass(path) {
        const baseClassName = 'list-item';
        return !getIsActive(path) ? baseClassName : baseClassName + ' active';
    }

    function renderListWithText() {
        return domainRoutes.filter(route => route.included).map((route) => {
            const IconComponent = route.icon;
            return (
                <ListItem
                    key={route.name}
                    onClick={() => changeRoute(route)}
                    className={getListItemClass(route.path)}
                    data-testid={route.testId}
                >
                    <ListItemIcon>
                        <IconComponent/>
                    </ListItemIcon>
                    <div className='list-item-text hide-in-mobile'>{route.name}</div>
                </ListItem>
            )
        })
    }

    return (
        <Drawer
            variant='persistent'
            open={true}
            PaperProps={{className: 'drawer-paper theme-navigation-bar' + (hideTopBar ? ' top-hidden' : '') + (Utility.isMobile() ? '' : ' open')}}
            className='sidebar-drawer workspace-sidebar'>
            <div className='drawer-top hide-in-mobile'>
                <ListItem className='list-item'>
                    <ListItemText className='list-item-text no-icon'>
                        <div className='drawer-head-ownership hide-in-tablet'>
                            {generalStore.translate('workspaceManagement')}
                        </div>
                    </ListItemText>
                </ListItem>
            </div>
            <List className='sidebar-routes domain-routes'>
                {renderListWithText()}
            </List>
        </Drawer>

    );
});

export default DomainSidebar;
